<template>
  <el-cascader class="selector" :placeholder="$t('shared.selectChainAndRule')" :value="value" :options="chains" filterable change-on-select @change="$emit('input', $event)"></el-cascader>
</template>

<script>
import api from './api'
export default {
  name: 'chain-selector',
  props: ['value'],
  data() {
    return {
      loading: false,
      chains: []
    }
  },
  created() {
    this.loading = true
    api.getChains().then(response => {
      this.loading = false
      this.chains = response.data
    })
  }
}
</script>

<style scoped>
.selector {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/chainselector/ChainSelector.vue